/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_P1Inputs */

const en_guide_large_json_files_s5_p1 = /** @type {(inputs: Guide_Large_Json_Files_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON isn't always the best format for very large datasets. Consider these alternatives for specific scenarios:`)
};

const ko_guide_large_json_files_s5_p1 = /** @type {(inputs: Guide_Large_Json_Files_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 매우 큰 데이터셋에 항상 최적의 포맷은 아닙니다. 특정 시나리오에 대해 다음 대안을 고려하세요:`)
};

const ja_guide_large_json_files_s5_p1 = /** @type {(inputs: Guide_Large_Json_Files_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONは非常に大きなデータセットにとって常に最適なフォーマットとは限りません。特定のシナリオでは以下の代替手段を検討してください：`)
};

/**
* | output |
* | --- |
* | "JSON isn't always the best format for very large datasets. Consider these alternatives for specific scenarios:" |
*
* @param {Guide_Large_Json_Files_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_p1(inputs)
	return ja_guide_large_json_files_s5_p1(inputs)
});